
export default class DecodingCommand
{
    public audioId:string;
    public code:string;
    public isInstruction:boolean;
    public placement:string;
    public position:number;
}